import React,{useState}     from 'react';
import * as S               from './styles';
import * as GV              from '../../../global/globalVariables';
import imageTop1            from '../../../assets/glenfernmultistoreytop1.png';
import imageTop2            from '../../../assets/glenfernmultistoreytop1.png';
import image1               from '../../../assets/glenfernmultistoreyimg1.png';
import googleplay           from '../../../assets/googleplay.png';
import Trailer              from './trailer';
import { i18n }             from '../../../translate/i18n';
import Contact              from '../../../components/Mail';

function HomeCarPark() {
    
    const [odd, setOdd] = useState(false);
    
    React.useEffect(() => {
        window.scrollTo(0, 0);
        setOdd( isOdd(randomNumberInRange(1, 9)) );
    }, []);
    
    function randomNumberInRange(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function isOdd(num) {
        return Math.abs(num % 2) === 1;
    }
    
    function buttonDownload() {
        window.open('https://play.google.com/store/apps/details?id=com.kodasware.glenfernmultistorey', '_blank');
    }

    return (
        <S.Container>
           
            { odd ? <S.TopImage><img src={imageTop1} alt=''></img></S.TopImage> : <S.TopImage><img src={imageTop2} alt=''></img></S.TopImage> }
            <S.HeaderApp>{i18n.t('header.app7')}</S.HeaderApp>
                        
            <div id="about"></div>
            <S.TitleOption>{i18n.t('carpark.menu1')}</S.TitleOption>
            <S.DescOption>{i18n.t('carpark.menu1Desc')}</S.DescOption>
            <S.DescOption>{i18n.t('carpark.menu1bDesc')}</S.DescOption>
            <S.DescOption>{i18n.t('carpark.menu1cDesc')}</S.DescOption>
            <S.DescOption>{i18n.t('carpark.menu1dDesc')}</S.DescOption>
            <S.DescOption>{i18n.t('carpark.menu1eDesc')}</S.DescOption>
            <br></br><br></br><br></br>
            
            <S.DivisionLine></S.DivisionLine>
            <div id="features"></div>
            <S.TitleOption>{i18n.t('carpark.menu2')}</S.TitleOption>
            <S.DescOption>{i18n.t('carpark.menu2aDesc')}</S.DescOption>
            <S.DescOption>{i18n.t('carpark.menu2bDesc')}</S.DescOption>
            <S.DescOption>{i18n.t('carpark.menu2cDesc')}</S.DescOption>
            <S.DescOption>{i18n.t('carpark.menu2dDesc')}</S.DescOption>
            <S.DescOption>{i18n.t('carpark.menu2eDesc')}</S.DescOption>
            <S.DescOption>{i18n.t('carpark.menu2fDesc')}</S.DescOption>
            <S.GuideImage><img src={image1} alt=""></img></S.GuideImage>
            <br></br><br></br><br></br>

            <S.DivisionLine></S.DivisionLine>
            <div id="download"></div>
            <S.TitleOption>{i18n.t('carpark.menu3')}</S.TitleOption>
            <S.DescOption>{i18n.t('carpark.menu3Desc')}</S.DescOption>
            <br></br>
            <S.MidiaPlay onClick={buttonDownload}><img src={googleplay} alt=''></img></S.MidiaPlay>
            <br></br><br></br><br></br>

            <S.DivisionLine></S.DivisionLine>
            <div id="contact"></div>
            <S.TitleOption>{i18n.t('carpark.menu4')}</S.TitleOption>
            <S.GuideDescTitle>{i18n.t('carpark.menu4Title')}</S.GuideDescTitle>
            <S.GuideDesc>{i18n.t('carpark.menu4Desc')}</S.GuideDesc>
            <Contact local={GV.CONTACT_LOCAL_APP_EXPENSES_AI}></Contact>
            <br></br><br></br><br></br>

            <Trailer></Trailer>
        </S.Container>
    )
}

export default HomeCarPark;